import { ICertificates } from "../interfaces/ICertificates";




export const certificates: ICertificates[] = [
{
    dateIssued: "Issued Oct 2022",
    image: "",
    link: "https://bcert.me/bc/html/show-badge.html?b=qnhembbq",
    organization: "Scrum AllianceScrum Alliance",
    title: "Certified ScrumMaster® (CSM®)Certified ScrumMaster® (CSM®)",
    credentialID:"1667971", 
},
{
    dateIssued: "Issued Oct 2021 · Expires Oct 2024",
    image: "",
    link: "https://www.credly.com/badges/31ea2975-f944-4e6d-81c3-4c6c563b46fd?source=linked_in_profile",
    organization: "Amazon Web Services (AWS)",
    title: "AWS Certified Solutions Architect - Associate",
    credentialID:undefined, 
},
{
    dateIssued: "Issued Sep 2021 · Expires Sep 2024",
    image: "",
    link: "https://www.credly.com/badges/5c042b93-ff7d-45b3-a5e2-ed111abe6334/linked_in_profile",
    organization: "Amazon Web Services (AWS)",
    title: "AWS Certified Cloud Practitioner",
    credentialID:undefined, 
},
{
    dateIssued: "Issued Feb 2021",
    image: "",
    link: "https://www.credly.com/badges/5c042b93-ff7d-45b3-a5e2-ed111abe6334/linked_in_profile",
    organization: "Udemy",
    title: "The Complete 2021 Flutter Development Bootcamp with Dart",
    credentialID:"UC-21e97c1a-f167-4fa0-aa10-4e14c61be814", 
}
  ];






 


